import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RoleProfile } from "../configurationAPI";
import Modal, { Styles } from "react-modal";
import {
  changeActiveComponent,
  changeOwnInfo,
  changeOwnRoles,
  changePasswordData,
  changePasswordErrorData,
  createRoleProfile,
  emptyGeneratedPassword,
  getAccountData,
  getCurrentRoles,
  getRoleOptions,
  getRoleProfiles,
  resetOwnPassword,
  resetRoleProfiledata,
  selectAccountData,
  selectActiveConfigurationComponent,
  selectChangeOwnInfoLoading,
  selectChangeRolesError,
  selectChangeRolesLoading,
  selectChangeUserInfoError,
  selectCurrentRoles,
  selectCurrentRolesLoading,
  selectLoadingAccount,
  selectPasswordChangeLoading,
  selectPasswordData,
  selectPasswordDataError,
  selectResetOwnPasswordLoading,
  selectRoleOptions,
  selectRoleOptionsLoading,
  selectRoleProfiles,
  selectRPCreationError,
  selectRPCreationLoading,
  setChangeRolesError,
  setChangeUserInfoError,
} from "../configurationSlice";
import { AccountView } from "./components/AccountView";
import { RolesComponent } from "./components/RolesComponent";
import { selectRoles } from "../../common/commonSlice";
import { useCookies } from "react-cookie";
import { addHours } from "date-fns";
import { ExtraConfigView } from "./components/ExtraConfigView";
import {
  getAsesores,
  selectAsesores,
} from "../../services/analytics/analyticsSlice";
import { ExpandibleContent } from "../../services/components/ExpandibleContent";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { DropDown } from "../../common/components/Btns/DropDown";
import { ReactComponent as EyeIcon } from "../../../Assets/common/images/eyePassword.svg";
import { ReactComponent as EyeOffIcon } from "../../../Assets/common/images/eyePasswordOff.svg";
import { Tooltip } from "../../common/components/Tooltip";

Modal.setAppElement("#root");
const customStylesModalRoles: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "75%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};
const customStylesModalChangeInfo: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "50%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};
const customStylesModalChangePassword: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "40%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
};
export const Account = () => {
  const dispatch = useAppDispatch();

  const loadingAccount = useAppSelector(selectLoadingAccount);
  const userData = useAppSelector(selectAccountData);
  const passwordData = useAppSelector(selectPasswordData);
  const passwordDataError = useAppSelector(selectPasswordDataError);
  const loadingPasswordChange = useAppSelector(selectPasswordChangeLoading);
  const roleOptionsLoading = useAppSelector(selectRoleOptionsLoading);
  const roleOptions = useAppSelector(selectRoleOptions);
  const rpCreationLoading = useAppSelector(selectRPCreationLoading);
  const rpCreationError = useAppSelector(selectRPCreationError);
  const currentRoles = useAppSelector(selectCurrentRoles);
  const currentRolesLoading = useAppSelector(selectCurrentRolesLoading);
  const activeComponent = useAppSelector(selectActiveConfigurationComponent);
  const resetPasswordLoading = useAppSelector(selectResetOwnPasswordLoading);
  const changeInfoLoading = useAppSelector(selectChangeOwnInfoLoading);
  const changeUserInfoError = useAppSelector(selectChangeUserInfoError);
  const changeRolesLoading = useAppSelector(selectChangeRolesLoading);
  const changeRolesError = useAppSelector(selectChangeRolesError);
  const roles = useAppSelector(selectRoles);
  const roleProfiles = useAppSelector(selectRoleProfiles);
  const asesores = useAppSelector(selectAsesores);

  // change password
  const [modalPasswordIsOpen, setModalPasswordIsOpen] = useState(false);
  const [showPasswordOld, setShowPasswordOld] = useState(false);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [finishedChangePassword, setFinishedChangePassword] = useState(false);
  const [generalPasswordError, setGeneralPasswordError] = useState("");
  // change info
  const [modalChangeInfoIsOpen, setModalChangeInfoIsOpen] = useState(false);
  const [changeInfoError, setChangeInfoError] = useState<{
    nameError: string;
    phoneNumberError: string;
    identificationError: string;
  }>({
    nameError: "",
    phoneNumberError: "",
    identificationError: "",
  });
  const [changeInfoReq, setChangeInfoReq] = useState<{
    name: string;
    phoneNumber: string;
    identification: string;
    motive?: string;
  }>({ name: "", phoneNumber: "", identification: "" });
  // roles changing
  const [modalChangeRolesIsOpen, setModalChangeRolesIsOpen] = useState(false);
  const [rolesChangingType, setRolesChangingType] = useState<
    "SPECIFIC" | "ROLE_PROFILE" | "NONE"
  >();
  const [roleProfileCreate, setRoleProfileCreate] = useState(false);
  const [newRoleProfile, setNewRoleProfile] = useState<
    RoleProfile | undefined
  >();
  const [roleProfileIdAssigned, setRoleProfileIdAssigned] = useState<
    string | undefined
  >();
  const [_, setCookie] = useCookies(["token"]);

  const canChangePassword = () => {
    if (
      passwordDataError.oldPasswordError === "" &&
      passwordDataError.newPasswordError === "" &&
      passwordDataError.newPasswordRepeatError === "" &&
      passwordData.newPassword &&
      passwordData.newPasswordRepeat &&
      passwordData.oldPassword
    ) {
      if (passwordData.newPassword === passwordData.newPasswordRepeat) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };
  const changePasswordContent = () => {
    if (finishedChangePassword) {
      return (
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Restablecimiento de contraseña
          </div>{" "}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px 0",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 0px 2px",
              }}
            >
              Tu contraseña ha sido restablecida con exito
            </p>
          </div>
          <button
            onClick={(e) => {
              e.preventDefault();
              setFinishedChangePassword(false);
              setModalPasswordIsOpen(false);
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "40px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            Finalizar
          </button>
        </div>
      );
    } else {
      return (
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Restablecimiento de contraseña
          </div>{" "}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "10px 0",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "start",
                margin: "0 0 10px 2px",
              }}
            >
              Para restablecer tu contraseña, debes ingresar tu contraseña
              actual y crear una nueva contraseña
            </p>
            <label
              htmlFor="passwordUserOld"
              style={{
                width: "65%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Contraseña Actual
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => {
                    const value = e.target.value;

                    let error = "";

                    dispatch(
                      changePasswordData({
                        ...passwordData,
                        oldPassword: value,
                      })
                    );
                    dispatch(
                      changePasswordErrorData({
                        ...passwordDataError,
                        oldPasswordError: error,
                      })
                    );
                  }}
                  id="passwordUserOld"
                  name="passwordUserOld"
                  type={showPasswordOld ? "text" : "password"}
                  placeholder="Contraseña Actual"
                  value={passwordData.oldPassword}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 32px 8px 8px", // Add space for icon
                    minHeight: "24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />

                {/* Toggle Visibility Icon */}
                <span
                  onClick={() => setShowPasswordOld((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <Tooltip text={showPasswordOld ? "Ocultar" : "Mostrar"}>
                    {showPasswordNew ? (
                      <EyeIcon width={"25px"} height={"25px"} />
                    ) : (
                      <EyeOffIcon width={"25px"} height={"25px"} />
                    )}
                  </Tooltip>
                </span>
              </div>

              {passwordDataError.oldPasswordError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {passwordDataError.oldPasswordError}
                </p>
              )}
            </label>
            <label
              htmlFor="passwordUserNew"
              style={{
                width: "65%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Contraseña nueva
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => {
                    const value = e.target.value;

                    let error = "";
                    if (value.length <= 8) {
                      error = "La contrasena debe tener al menos 8 caracteres";
                    } else if (
                      !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
                    ) {
                      error =
                        "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())";
                    } else if (!/[0-9]/.test(value)) {
                      error =
                        "La contrasena debe contener por lo menos un número";
                    }

                    dispatch(
                      changePasswordData({
                        ...passwordData,
                        newPassword: value,
                      })
                    );
                    dispatch(
                      changePasswordErrorData({
                        ...passwordDataError,
                        newPasswordError: error,
                      })
                    );
                  }}
                  id="passwordUserNew"
                  name="passwordUserNew"
                  type={showPasswordNew ? "text" : "password"}
                  placeholder="Contraseña segura"
                  value={passwordData.newPassword}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 32px 8px 8px", // Add space for icon
                    minHeight: "24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />

                {/* Toggle Visibility Icon */}
                <span
                  onClick={() => setShowPasswordNew((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <Tooltip text={showPasswordNew ? "Ocultar" : "Mostrar"}>
                    {showPasswordNew ? (
                      <EyeIcon width={"25px"} height={"25px"} />
                    ) : (
                      <EyeOffIcon width={"25px"} height={"25px"} />
                    )}
                  </Tooltip>
                </span>
              </div>

              {passwordDataError.newPasswordError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {passwordDataError.newPasswordError}
                </p>
              )}
            </label>

            <label
              htmlFor="passwordUserNewRepeat"
              style={{
                width: "65%",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Confirma la contraseña nueva
              </p>

              <div style={{ position: "relative", width: "100%" }}>
                <input
                  onChange={(e) => {
                    const value = e.target.value;

                    let error = "";
                    if (value.length <= 8) {
                      error = "La contrasena debe tener al menos 8 caracteres";
                    } else if (
                      !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)
                    ) {
                      error =
                        "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())";
                    } else if (!/[0-9]/.test(value)) {
                      error =
                        "La contrasena debe contener por lo menos un número";
                    }

                    dispatch(
                      changePasswordData({
                        ...passwordData,
                        newPasswordRepeat: value,
                      })
                    );
                    dispatch(
                      changePasswordErrorData({
                        ...passwordDataError,
                        newPasswordRepeatError: error,
                      })
                    );
                  }}
                  id="passwordUserNewRepeat"
                  name="passwordUserNewRepeat"
                  type={showPasswordRepeat ? "text" : "password"}
                  placeholder="Ingresa de nuevo la contraseña"
                  value={passwordData.newPasswordRepeat}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 32px 8px 8px", // space for icon
                    minHeight: "24px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />

                {/* Toggle Icon */}
                <span
                  onClick={() => setShowPasswordRepeat((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#000",
                  }}
                >
                  <Tooltip text={showPasswordRepeat ? "Ocultar" : "Mostrar"}>
                    {showPasswordRepeat ? (
                      <EyeIcon width={"25px"} height={"25px"} />
                    ) : (
                      <EyeOffIcon width={"25px"} height={"25px"} />
                    )}
                  </Tooltip>
                </span>
              </div>

              {passwordDataError.newPasswordRepeatError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {passwordDataError.newPasswordRepeatError}
                </p>
              )}
            </label>

            {passwordDataError.oldPasswordError && (
              <p
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  margin: "0 0 2px 2px",
                  fontWeight: "500",
                  color: "#cf4259",
                }}
              >
                {passwordDataError.oldPasswordError}
              </p>
            )}
            {generalPasswordError && (
              <p
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  margin: "0 0 2px 2px",
                  fontWeight: "500",
                  color: "#cf4259",
                }}
              >
                {generalPasswordError}
              </p>
            )}
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "start",
                margin: "10px 0 20px 2px",
              }}
            >
              Recuerda almacenarla de forma segura, y en caso de olvidarla
              podrás recuperarla utilizando 'Olvide mi contraseña' en el inicio
              de sesión.
            </p>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setFinishedChangePassword(false);
                  setModalPasswordIsOpen(false);
                  changePasswordData({
                    newPassword: "",
                    newPasswordRepeat: "",
                    oldPassword: "",
                  });

                  dispatch(
                    changePasswordErrorData({
                      newPasswordError: "",
                      newPasswordRepeatError: "",
                      oldPasswordError: "",
                    })
                  );
                }}
                className="flex-col text-medium text-bold"
                style={{
                  background: "transparent",
                  width: "35%",
                  height: "40px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "1px solid #1A617D",
                  color: "#1A617D",
                }}
              >
                Cancelar
              </button>
              <button
                disabled={
                  !canChangePassword() || loadingPasswordChange === "pending"
                }
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(resetOwnPassword()).then((x) => {
                    if (x.meta.requestStatus === "fulfilled") {
                      setFinishedChangePassword(true);
                      dispatch(
                        changePasswordData({
                          newPassword: "",
                          newPasswordRepeat: "",
                          oldPassword: "",
                        })
                      );
                      dispatch(
                        changePasswordErrorData({
                          newPasswordError: "",
                          newPasswordRepeatError: "",
                          oldPasswordError: "",
                        })
                      );
                    }
                  });
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "35%",
                  height: "40px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "none",
                }}
              >
                {loadingPasswordChange === "pending" ? (
                  <ClipLoader color="white" size={"20px"} />
                ) : (
                  "Cambiar contraseña"
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  const canFinishBasicInfo = () => {
    if (changeInfoReq.name.length === 0) {
      return false;
    }
    if (changeInfoError.nameError.length > 0) {
      return false;
    }
    if (changeInfoError.identificationError.length > 0) {
      return false;
    }
    if (changeInfoError.phoneNumberError.length > 0) {
      return false;
    }
    return true;
  };
  const changeInfoContent = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="text-large text-bold"
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "15px",
          }}
        >
          Cambiar Información Básica
        </div>
        <p
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "500",
            textAlign: "center",
            margin: "0 0 2px 0",
          }}
        >
          Modifique los campos que requiera cambiar a continuación.
          <br />
          (los campos con "*" son obligatorios).
        </p>
        <div
          className="flex-col"
          style={{
            width: "100%",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "12px",
              width: "90%",
              alignSelf: "center",
            }}
          >
            <label
              htmlFor="nameUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Nombre del usuario{" "}
                <span
                  style={{
                    color: "#cf4259",
                  }}
                >
                  *
                </span>
              </p>
              <input
                onChange={(e) => {
                  if (e.target.value.length > 40) {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "El nombre debe tener menos de 40 caracteres",
                    });
                  } else if (e.target.value.length === 0) {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "El nombre no puede estar vacío",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      nameError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    name: e.target.value,
                  });
                }}
                id="nameUser"
                name="nameUser"
                type="text"
                placeholder="Nombre"
                value={changeInfoReq.name}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.nameError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.nameError}
                </p>
              )}
            </label>
            <label
              htmlFor="identificationUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Identificación
              </p>
              <input
                onChange={(e) => {
                  if (e.target.value.length > 20) {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError:
                        "La identificación debe tener menos de 20 caracteres",
                    });
                  } else if (
                    e.target.value.length !== 0 &&
                    e.target.value.length < 8
                  ) {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError:
                        "La identificación debe tener al menos 8 caracteres",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      identificationError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    identification: e.target.value,
                  });
                }}
                id="identificatonUser"
                name="identificatonUser"
                type="text"
                placeholder="Opcional"
                value={changeInfoReq.identification}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.identificationError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.identificationError}
                </p>
              )}
            </label>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: "12px",
              width: "90%",
              alignSelf: "center",
            }}
          >
            <label
              htmlFor="phoneNumberUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Número de Telefono
              </p>
              <input
                onChange={(e) => {
                  if (
                    e.target.value.length !== 0 &&
                    e.target.value.length < 8
                  ) {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError:
                        "El telefono debe tener al menos 8 caracteres",
                    });
                  } else if (e.target.value.length > 16) {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError:
                        "El telefono debe tener menos de 16 caracteres",
                    });
                  } else {
                    setChangeInfoError({
                      ...changeInfoError,
                      phoneNumberError: "",
                    });
                  }
                  setChangeInfoReq({
                    ...changeInfoReq,
                    phoneNumber: e.target.value,
                  });
                }}
                id="phoneNumberUser"
                name="phoneNumberUser"
                type="text"
                placeholder="Ej: 3112345678 (Opcional)"
                value={changeInfoReq.phoneNumber}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
              {changeInfoError.phoneNumberError && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {changeInfoError.phoneNumberError}
                </p>
              )}
            </label>
            <label
              htmlFor="motiveUser"
              style={{
                width: "100%",
                marginRight: "10px",
                alignSelf: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  color: "#000",
                  fontWeight: "500",
                  textAlign: "start",
                  margin: "0 0 2px 2px",
                }}
              >
                Motivo de cambio
              </p>
              <input
                onChange={(e) => {
                  setChangeInfoReq({
                    ...changeInfoReq,
                    motive: e.target.value,
                  });
                }}
                id="motiveUser"
                name="motiveUser"
                type="text"
                placeholder="Opcional"
                value={changeInfoReq.motive}
                style={{
                  border: "1px solid rgba(0,0,0,0.5)",
                  borderRadius: "6px",
                  background: "transparent",
                  padding: "8px 8px 8px 8px",
                  minHeight: "24px",
                  fontSize: "12px",
                  fontWeight: "500",
                  textAlign: "start",
                  color: "#000",
                  width: "100%",
                }}
              />
            </label>
          </div>
          {changeUserInfoError && (
            <p
              style={{
                fontSize: "13px",
                color: "#cf4259",
                fontWeight: "500",
                textAlign: "center",
                marginTop: "10px",
                marginBottom: "5px",
              }}
            >
              {changeUserInfoError}
            </p>
          )}
        </div>
        <div
          className="flex-row"
          style={{
            width: "80%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "15px",
            alignSelf: "center",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setChangeInfoReq({
                name: "",
                phoneNumber: "",
                identification: "",
                motive: undefined,
              });
              setChangeInfoError({
                nameError: "",
                identificationError: "",
                phoneNumberError: "",
              });
              dispatch(setChangeUserInfoError(undefined));
              setModalChangeInfoIsOpen(false);
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={!canFinishBasicInfo() || changeInfoLoading === "pending"}
            onClick={(e) => {
              e.preventDefault();
              dispatch(
                changeOwnInfo({
                  name: changeInfoReq.name,
                  identification: changeInfoReq.identification,
                  phoneNumber: changeInfoReq.phoneNumber,
                  motive: changeInfoReq.motive,
                })
              ).then((x) => {
                if (x.meta.requestStatus === "fulfilled") {
                  setModalChangeInfoIsOpen(false);
                  setChangeInfoError({
                    nameError: "",
                    phoneNumberError: "",
                    identificationError: "",
                  });
                  setChangeInfoReq({
                    name: "",
                    phoneNumber: "",
                    identification: "",
                    motive: undefined,
                  });
                }
              });
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {changeInfoLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Confirmar cambios"
            )}
          </button>
        </div>
      </div>
    );
  };

  const getAsesor = () => {
    if (asesores) {
      return asesores.find((asesor) => asesor.id === userData?.id);
    }
  };
  const getRoleProfile = () => {
    if (userData && userData.roleProfileId && roleProfiles) {
      return roleProfiles.find(
        (roleProfile) => roleProfile.id === userData.roleProfileId
      );
    } else {
      return undefined;
    }
  };

  const rolesVisible = () => {
    if (roles.includes("users.admin") || roles.includes("users.edit")) {
      return "visible";
    } else {
      return "hidden";
    }
  };

  const roleProfileNameError = () => {
    if (newRoleProfile === undefined) {
      return "error";
    }
    roleProfiles.forEach((role) => {
      if (role.name === newRoleProfile.name) {
        return "Ya existe un rol con ese nombre";
      }
    });
    return "";
  };
  const roleProfileAssign = () => {
    if (roleOptionsLoading === "pending") {
      return <ClipLoader color={"#fff"} loading={true} size={35} />;
    } else {
      const options = roleProfiles.map((rp) => {
        return {
          label: rp.name!,
          value: rp.id!,
        };
      });
      return (
        <DropDown
          key={"roleProfile"}
          title=""
          maxContent
          options={options}
          onChange={(e) => {
            if (!e || e?.value === undefined) {
              setRoleProfileIdAssigned(undefined);
            }
            if (e?.value === "") {
              setRoleProfileIdAssigned(undefined);
            } else {
              setRoleProfileIdAssigned(e?.value);
            }
          }}
        />
      );
    }
  };

  const roleListHaveSameRoles = (
    currentRoles?: string[],
    newRoles?: string[]
  ) => {
    if (currentRoles === undefined || newRoles === undefined) {
      return false;
    }
    if (currentRoles.length !== newRoles.length) {
      return false;
    }
    return currentRoles.every((role) => newRoles.includes(role));
  };
  const rolesChangeContent = () => {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="text-large text-bold"
          style={{
            textAlign: "center",
            fontSize: "18px",
            marginBottom: "15px",
          }}
        >
          Cambiar permisos
        </div>
        {roleProfiles && roleProfiles.length > 0 ? (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, puedes asignar al usuario los permisos que va a
            tener en la plataforma.
            <br /> Puedes seleccionar un rol de permisos o permisos específicos
            para este usuario.
          </p>
        ) : (
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 15px 0",
            }}
          >
            A continuación, debes asignar al usuario los permisos que va a tener
            el usuario en la plataforma.
          </p>
        )}
        {rpCreationError && (
          <p
            style={{
              fontSize: "13px",
              color: "#cf4259",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {rpCreationError}
          </p>
        )}
        {changeRolesError && (
          <p
            style={{
              fontSize: "13px",
              color: "#cf4259",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            {changeRolesError}
          </p>
        )}

        <ExpandibleContent
          title={"Permisos específicos"}
          isActive={rolesChangingType === "SPECIFIC"}
          content={
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: "0 10px 15px 10px",
                minHeight: "200px",
                overflowY: "auto",
              }}
            >
              <h5
                style={{
                  margin: "0px 0px 5px 0px",
                  color: "#fff",
                  fontSize: "17px",
                  fontWeight: "700",
                  textAlign: "start",
                }}
              >
                Permisos específicos
              </h5>
              <p
                style={{
                  margin: "0px 0px 15px 0px",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                Selecciona los permisos específicos que deseas asignar al
                usuario a continuación:
              </p>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <RolesComponent
                  width="70%"
                  immutableRoles={[]}
                  currentRoles={currentRoles}
                  predeterminedRoles={roleOptions}
                  loading={roleOptionsLoading}
                  visibility={"visible"}
                  darkMode
                  dontShowButtons
                  ownRoles
                />
                <div
                  className="flex-col"
                  style={{
                    width: "30%",
                    alignItems: "start",
                  }}
                >
                  {!roleListHaveSameRoles(currentRoles, userData?.roles) && (
                    <FormControlLabel
                      style={{
                        color: "#fff",
                        width: "90%",
                        margin: "5px 0 5px 0px",
                        fontFamily: "Open Sans",
                      }}
                      control={
                        <Checkbox
                          style={{ color: "#fff", alignSelf: "start" }}
                          checked={roleProfileCreate}
                          onChange={() => {
                            if (!roleProfileCreate) {
                              setNewRoleProfile({
                                clientId: "",
                                description: "",
                                name: "",
                                roles: [],
                              });
                            } else {
                              setNewRoleProfile(undefined);
                            }

                            setRoleProfileCreate((prev) => !prev);
                          }}
                        />
                      }
                      label={
                        <span
                          style={{
                            fontFamily: "Open Sans",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#fff",
                          }}
                        >
                          ¿Guardar como rol?
                        </span>
                      }
                    />
                  )}
                  {currentRoles.length > 0 && roleProfileCreate && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "12px",
                        width: "80%",
                        alignSelf: "center",
                      }}
                    >
                      <label
                        htmlFor="name"
                        style={{
                          width: "100%",
                          marginRight: "10px",
                          alignSelf: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "start",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#fff",
                            fontWeight: "500",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                          }}
                        >
                          Nombre
                        </p>
                        <input
                          onChange={(e) => {
                            setNewRoleProfile({
                              ...newRoleProfile!,
                              name: e.target.value || "",
                            });
                          }}
                          id="name"
                          name="name"
                          type="text"
                          placeholder="Nombre del rol"
                          value={newRoleProfile?.name || ""}
                          style={{
                            border: "1px solid rgba(255,255,255,0.5)",
                            borderRadius: "6px",
                            background: "transparent",
                            padding: "8px 8px 8px 8px",
                            minHeight: "24px",
                            fontSize: "12px",
                            fontWeight: "500",
                            textAlign: "start",
                            color: "#fff",
                            width: "100%",
                          }}
                        />
                      </label>
                      {roleProfileNameError() && (
                        <p
                          style={{
                            fontSize: "11px",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                            fontWeight: "500",
                            color: "#cf4259",
                          }}
                        >
                          {roleProfileNameError()}
                        </p>
                      )}
                    </div>
                  )}
                  {currentRoles.length > 0 && roleProfileCreate && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "15px",
                        marginTop: "5px",
                        width: "83%",
                        alignSelf: "center",
                      }}
                    >
                      <label
                        htmlFor="descripcion"
                        style={{
                          width: "100%",
                          marginRight: "10px",
                          alignSelf: "center",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "start",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#fff",
                            fontWeight: "500",
                            textAlign: "start",
                            margin: "0 0 2px 2px",
                          }}
                        >
                          Descripción
                        </p>
                        <input
                          onChange={(e) => {
                            setNewRoleProfile({
                              ...newRoleProfile!,
                              description: e.target.value || "",
                            });
                          }}
                          id="descripcion"
                          name="descripcion"
                          type="text"
                          placeholder="Opcional"
                          value={newRoleProfile?.description || ""}
                          style={{
                            border: "1px solid rgba(255,255,255,0.5)",
                            borderRadius: "6px",
                            background: "transparent",
                            padding: "8px 8px 8px 8px",
                            minHeight: "24px",
                            fontSize: "12px",
                            fontWeight: "500",
                            textAlign: "start",
                            color: "#fff",
                            width: "100%",
                          }}
                        />
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>
          }
          barColor="#1A617D"
          contentColor="rgb(61, 105, 122)"
          onClickFunction={() => {
            if (rolesChangingType === "SPECIFIC") {
              setRolesChangingType("NONE");
            }
            setRolesChangingType("SPECIFIC");
          }}
        />
        {roleProfiles && roleProfiles.length > 0 && (
          <ExpandibleContent
            title={"Roles"}
            isActive={rolesChangingType === "ROLE_PROFILE"}
            content={
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 10px 15px 10px",
                  minHeight: "200px",
                }}
              >
                <h5
                  style={{
                    margin: "0px",
                    color: "#fff",
                    fontSize: "17px",
                    fontWeight: "700",
                    textAlign: "start",
                  }}
                >
                  Roles
                </h5>
                <p
                  style={{
                    margin: "0px",
                    color: "#fff",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Selecciona un rol para este usuario.
                </p>
                {roleProfileAssign()}
              </div>
            }
            barColor="#1A617D"
            contentColor="rgb(29, 72, 89)"
            onClickFunction={() => {
              if (rolesChangingType === "ROLE_PROFILE") {
                setRolesChangingType("NONE");
              }
              setRolesChangingType("ROLE_PROFILE");
            }}
          />
        )}
        <div
          className="flex-row"
          style={{
            width: "80%",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginTop: "10px",
            alignSelf: "center",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              setModalChangeRolesIsOpen(false);
              setRolesChangingType("NONE");
              dispatch(resetRoleProfiledata());
              dispatch(setChangeRolesError(undefined));
              setRoleProfileIdAssigned(undefined);
              dispatch(emptyGeneratedPassword());
            }}
            className="flex-col text-medium text-bold"
            style={{
              background: "transparent",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "1px solid #1A617D",
              color: "#1A617D",
            }}
          >
            Cancelar
          </button>
          <button
            disabled={changeRolesLoading === "pending"}
            onClick={(e) => {
              e.preventDefault();
              if (currentRoles.length > 0 && roleProfileCreate) {
                dispatch(createRoleProfile(newRoleProfile!)).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    let payload = x.payload as RoleProfile;
                    setNewRoleProfile(undefined);
                    dispatch(getRoleProfiles());
                    setRoleProfileCreate(false);
                    dispatch(
                      changeOwnRoles({
                        roleProfileId: payload.id!,
                      })
                    ).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        setRolesChangingType("NONE");
                        dispatch(resetRoleProfiledata());
                        setModalChangeRolesIsOpen(false);
                        setRoleProfileIdAssigned(undefined);
                      }
                    });
                  }
                });
              } else {
                dispatch(
                  changeOwnRoles({
                    roleProfileId: roleProfileIdAssigned,
                  })
                ).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    setRolesChangingType("NONE");
                    setModalChangeRolesIsOpen(false);
                    setRoleProfileIdAssigned(undefined);
                    dispatch(resetRoleProfiledata());
                  }
                });
              }
            }}
            className="flex-col text-medium text-bold primary-color"
            style={{
              background: "#1A617D",
              width: "35%",
              height: "30px",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              border: "none",
            }}
          >
            {changeRolesLoading === "pending" ||
            rpCreationLoading === "pending" ? (
              <ClipLoader color="white" size={"20px"} />
            ) : (
              "Confirmar"
            )}
          </button>
        </div>
      </div>
    );
  };
  useEffect(() => {
    if (
      passwordDataError.newPasswordError === "" &&
      passwordDataError.newPasswordRepeatError === ""
    ) {
      if (passwordData.newPassword === passwordData.newPasswordRepeat) {
        setGeneralPasswordError("");
      } else {
        setGeneralPasswordError("Las contraseñas deben ser iguales");
      }
    } else {
      setGeneralPasswordError("");
    }
  }, [passwordData, passwordDataError]);
  useEffect(() => {
    if (activeComponent !== "Account") {
      dispatch(changeActiveComponent("Account"));
    }
    if (!userData && loadingAccount === "idle") {
      dispatch(getAccountData());
    }
    if (roleOptions.length === 0 && roleOptionsLoading === "idle") {
      dispatch(getRoleOptions());
    }
    if (currentRoles.length === 0 && currentRolesLoading === "idle") {
      dispatch(getCurrentRoles());
    }
    dispatch(getRoleProfiles());
  }, []);

  useEffect(() => {
    if (userData?.esAsesor) {
      dispatch(getAsesores());
    }
  }, [userData]);

  useEffect(() => {
    if (changeRolesLoading === "resolved" && userData?.generatedToken) {
      let now = new Date();
      let inAnHour = addHours(now, 1);
      setCookie(
        "token",
        { token: userData?.generatedToken, expiry: inAnHour.getTime() },
        {
          path: "/",
          expires: inAnHour,
          sameSite: "lax",
          secure: true,
        }
      );
      setModalChangeRolesIsOpen(true);
    }
  }, [resetPasswordLoading, changeRolesLoading]);

  if (loadingAccount === "idle") {
    return (
      <div
        style={{
          width: "100%",
          height: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "1%",
        }}
      >
        <ClipLoader color="#FFF" size={"200px"} />
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "90%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          padding: "1%",
        }}
      >
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalRoles}
          isOpen={modalChangeRolesIsOpen}
          onRequestClose={() => {
            setModalChangeRolesIsOpen(false);
            setRolesChangingType("NONE");
            dispatch(setChangeRolesError(undefined));
            dispatch(resetRoleProfiledata());
            dispatch(emptyGeneratedPassword());
            setRoleProfileIdAssigned(undefined);
          }}
        >
          {rolesChangeContent()}
        </Modal>
        <Modal
          shouldCloseOnEsc
          shouldCloseOnOverlayClick
          shouldFocusAfterRender
          shouldReturnFocusAfterClose
          style={customStylesModalChangeInfo}
          isOpen={modalChangeInfoIsOpen}
          onRequestClose={() => {
            setChangeInfoReq({
              name: "",
              phoneNumber: "",
              identification: "",
              motive: undefined,
            });
            setChangeInfoError({
              nameError: "",
              identificationError: "",
              phoneNumberError: "",
            });
            dispatch(setChangeUserInfoError(undefined));
            setModalChangeInfoIsOpen(false);
          }}
        >
          {changeInfoContent()}
        </Modal>
        <Modal
          isOpen={modalPasswordIsOpen}
          style={customStylesModalChangePassword}
          contentLabel="Change Password"
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          onRequestClose={() => {
            setModalPasswordIsOpen(false);
            setFinishedChangePassword(false);
            dispatch(
              changePasswordData({
                newPassword: "",
                newPasswordRepeat: "",
                oldPassword: "",
              })
            );
            dispatch(
              changePasswordErrorData({
                newPasswordError: "",
                newPasswordRepeatError: "",
                oldPasswordError: "",
              })
            );
          }}
        >
          {changePasswordContent()}
        </Modal>
        {userData && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: "1%",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: "1%",
              }}
            >
              <div
                style={{
                  width: "49%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    margin: "0 0 2% 0",
                  }}
                >
                  {(roles.includes("users.edit") ||
                    roles.includes("users.admin")) && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setModalPasswordIsOpen(true);
                      }}
                      style={{
                        border: "none",
                        background: "rgba(0,0,0,0.2)",
                        borderRadius: "8px",
                        padding: "12px 8px 12px 8px",
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "#FFF",
                        marginRight: "2%",
                      }}
                    >
                      Restablecer contraseña
                    </button>
                  )}
                </div>
                <AccountView
                  asesorInfo={getAsesor()}
                  ownUser={true}
                  accountData={userData}
                  width="100%"
                  loading={loadingAccount}
                  changeInfoFunction={() => {
                    setChangeInfoReq({
                      identification: userData.identification,
                      name: userData.name,
                      phoneNumber: userData.phoneNumber,
                    });
                    setModalChangeInfoIsOpen(true);
                  }}
                  roleProfile={getRoleProfile()}
                />
              </div>

              <RolesComponent
                width="49%"
                currentRoles={userData?.roles!}
                changeRolesFunction={() => {
                  setModalChangeRolesIsOpen(true);
                }}
                immutableRoles={userData?.roles!}
                predeterminedRoles={roleOptions}
                loading={roleOptionsLoading}
                roleProfile={getRoleProfile()}
                visibility={rolesVisible()}
                disabled
                ownRoles
              />
            </div>
          </div>
        )}
        {roles.includes("extraConfig.edit") && <ExtraConfigView />}
      </div>
    );
  }
};
